module.exports = __webpack_public_path__ + "static/media/security-check_2.22d6d03d.png";